module.exports = __webpack_public_path__ + "img/coin-BTC.a5f55f65.svg";